var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#FFE7CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1776 16.85L24.2767 13.42C23.3131 12.86 22.121 12.86 21.1474 13.42L15.2564 16.85C14.2928 17.41 13.6968 18.45 13.6968 19.58V26.42C13.6968 27.54 14.2928 28.58 15.2564 29.15L21.1574 32.58C22.121 33.14 23.3131 33.14 24.2866 32.58L30.1876 29.15C31.1512 28.59 31.7472 27.55 31.7472 26.42V19.58C31.7373 18.45 31.1413 17.42 30.1776 16.85ZM22.717 18.34C23.9986 18.34 25.0317 19.38 25.0317 20.67C25.0317 21.96 23.9986 23 22.717 23C21.4355 23 20.4024 21.96 20.4024 20.67C20.4024 19.39 21.4355 18.34 22.717 18.34ZM25.3794 27.66H20.0547C19.25 27.66 18.7831 26.76 19.2301 26.09C19.9057 25.08 21.217 24.4 22.717 24.4C24.2171 24.4 25.5284 25.08 26.204 26.09C26.651 26.75 26.1741 27.66 25.3794 27.66Z",
    fill: "#23262F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9c904a53.svg";
export { ForwardRef as ReactComponent };